import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";

import { ThemeProvider } from "@material-tailwind/react";

// import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider } from "context/authContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <BrowserRouter>
      <ThemeProvider >
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </AuthProvider>
);
